import React, { useEffect, useState } from 'react';

import { MAILING_PAGE_TABS_IDS } from 'constants/mailing';
import { ConstraintVariants } from 'constants/shared';
import { TabItem } from 'interfaces';
import { getCountryList, getCustomMailTemplate, getEntities } from 'modules/custom-mail/action';
import { useAppDispatch } from 'modules/store';
import { DashboardLayout } from 'page-components';
import MailingForm from 'page-components/custom-mail/MailingForm';
import MailingSkeleton from 'page-components/custom-mail/MailingSkeleton';
import SentMailsList from 'page-components/custom-mail/SentMailsList';
import { Constraint, Tabs, TitleWithDescription } from 'shared-components';

export const MAILING_PAGE_TABS: TabItem[] = [
  { id: MAILING_PAGE_TABS_IDS.CREATION, name: 'Creation', component: MailingForm },
  { id: MAILING_PAGE_TABS_IDS.SENT, name: 'Sent', component: SentMailsList },
];

const Mailing = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([dispatch(getEntities()), dispatch(getCountryList()), dispatch(getCustomMailTemplate())]).finally(
      () => {
        setIsLoading(false);
      },
    );
  }, [dispatch]);

  return (
    <DashboardLayout>
      <Constraint variant={ConstraintVariants.FULL_ROUNDED}>
        <TitleWithDescription
          descriptionClassName='pt-2'
          title='Emails'
          description='Prepare and send a custom email. View sent emails.'
        />
        {isLoading ? <MailingSkeleton /> : <Tabs tabs={MAILING_PAGE_TABS} />}
      </Constraint>
    </DashboardLayout>
  );
};
export default Mailing;
